<template>
  <div class="quote-fi">
    <single-line-text-field-fi
      v-if="isEditMode || fields?.tag?.value"
      class="quote-fi__badge badge-fi"
      field-name="tag"
    />

    <div class="quote-fi__quote">
      <q>
        <single-line-text-field-fi field-name="quote" />
      </q>
    </div>

    <div
      v-if="isEditMode || fields?.author?.value"
      class="quote-fi__author"
    >
      <single-line-text-field-fi field-name="author" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { SingleLineTextFieldFi } from 'atoms';

import type { MultiLineTextField, SingleLineTextField } from '@/sitecoreFieldTypes';

defineOptions({
  name: 'QuoteFi',
});

withDefaults(
  defineProps<{
    fields?: {
      tag?: SingleLineTextField;
      quote?: MultiLineTextField;
      author?: SingleLineTextField;
    } | null;
  }>(),
  {
    fields: null,
  },
);
</script>

<style scoped src="./quote-fi" />

<style lang="scss">
.quote-fi {
  &__quote {
    span.scWebEditInput {
      display: inline;
    }
  }
}
</style>
